import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../../../shared/theme/colors';
import { styles } from '../posShared.styles';
import { formatPosMoney } from '../../application/posMoneyFormat';

type PosCartCollapseToggleProps = {
  expanded: boolean;
  onToggle: () => void;
  useMobileCartCompact: boolean;
  itemCountLabel: string;
  total: number;
};

export function PosCartCollapseToggle({
  expanded,
  onToggle,
  useMobileCartCompact,
  itemCountLabel,
  total,
}: PosCartCollapseToggleProps) {
  return (
    <TouchableOpacity
      style={styles.cartCollapseToggle}
      onPress={onToggle}
      accessibilityRole="button"
      accessibilityState={{ expanded }}
      accessibilityLabel={
        expanded ? 'Ocultar ítems del carrito' : 'Mostrar ítems del carrito'
      }
    >
      <Text style={styles.cartCollapseToggleLabel}>
        {expanded
          ? 'Ocultar ítems'
          : useMobileCartCompact
            ? `${itemCountLabel} · ${formatPosMoney(total)}`
            : 'Ver ítems'}
      </Text>
      <Ionicons
        name={expanded ? 'chevron-up' : 'chevron-down'}
        size={18}
        color={colors.textSecondary}
      />
    </TouchableOpacity>
  );
}
